import * as S from "./Inputs.style";
import { Control } from "react-hook-form";

export interface InputProps {
  id?: string | undefined;
  name?: string;
  width?: string;
  size?: "sm" | "md" | "lg";
  label?: string | undefined;
  placeholder?: string;
  defaultValue?: any;
  children?: React.ReactElement;
  control?: Control<any>;
  tabIndex?: number;
  required?: boolean;
  disabled?: boolean;
}

export const Inputs = (props: InputProps) => {
  return (
    <S.InputBox $width={props.width ?? "auto"} $size={props.size ?? "lg"}>
      {props.label && (
        <S.InputLabel $size={props.size ?? "lg"}>
          {props.label}
          {props.required && <span>*</span>}
        </S.InputLabel>
      )}

      {props.children}
    </S.InputBox>
  );
};
